import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-dsw',
    templateUrl: './dsw.component.html',
    styleUrls: ['./dsw.component.scss']
})
export class DswComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Dean Students Welfare: Empowering Student Success');
        this.meta.updateTag({
            name: 'description',
            content: `Meet ARNI’s Dean Students Welfare, dedicated to enhancing student well-being, fostering growth, and creating a supportive campus environment.`
        });
    }

}
